<div class="layout-container">
    <!-- Left panel -->
    <div *ngIf="showLeftPanel()" [style.width.px]="layoutViewerService.expandedLeftPanel ? widthLeftPanel : 0"
        class="panel">
        <button class="expand-button" [style.left.px]="positionButtonLeft"
            (click)="layoutViewerService.toggleLeftPanel()" qaid="toggle-left-panel">
            <twc-icon [shape]="iconExpandLeftPanel"></twc-icon>
        </button>
        <!-- HERE LEFT PANEL-->
        <div>
            <ng-content select="[leftPanel]"></ng-content>
        </div>

    </div>

    <!-- Divide left panel and widget (vertical) -->
    <div class="divider float-left" cdkDrag cdkDragLockAxis="x" (cdkDragStarted)="dragLeftPanelStarted()"
        (cdkDragMoved)="resizeLeftPanel($event)" (cdkDragEnded)="enableCanvasEvents()" qaid="divider-left-panel"
        *ngIf="showLeftPanel()">
    </div>

    <div class="widgets-zone" [ngStyle]="templateWidget" #widgetGrid>
        <!-- Main widget -->
        <div class="widget" [ngClass]="{'disable-canvas-events': areCanvasEventsDisabled()}">
            <!-- HERE MAIN WIDGET-->
            <ng-content select="[mainWidget]"></ng-content>
        </div>

        <div class="divider" qaid="divider-widget" *ngIf="layoutViewerService.splitedView"
            [ngClass]="{'float-left': !isHorizontalLayout(),'divider-horizontal':isHorizontalLayout()}" cdkDrag
            [cdkDragLockAxis]="isHorizontalLayout() ? 'y' : 'x'" (cdkDragEnded)="enableCanvasEvents()"
            (cdkDragStarted)="startResizeWidget()" (cdkDragMoved)="resizeWidget($event)">
        </div>

        <!-- Secondary widget -->
        <div class="widget" *ngIf="layoutViewerService.splitedView">
            <!-- HERE SECONDARY WIDGET-->
            <ng-content select="[secondaryWidget]"></ng-content>
        </div>
    </div>

    <!-- Divide right panel and widget (vertical) -->
    <div class="divider float-right" cdkDrag cdkDragLockAxis="x" (cdkDragStarted)="startResizeRightPanel()"
        (cdkDragMoved)="resizeRightPanel($event)" (cdkDragEnded)="enableCanvasEvents()" qaid="divider-right-panel"
        *ngIf="showRightPanel()">
    </div>


    <!-- Right panel -->
    <div *ngIf="showRightPanel()" [style.width.px]="layoutViewerService.expandedRightPanel ? widthRightPanel : 0"
        class="panel">
        <button class="expand-button" [style.right.px]="positionButtonRight"
            (click)="layoutViewerService.toggleRightPanel()" qaid="toggle-right-panel">
            <twc-icon [shape]="iconExpandRightPanel"></twc-icon>
        </button>
        <!-- HERE RIGHT PANEL-->
        <div>
            <ng-content select="[rightPanel]"></ng-content>
        </div>
    </div>
</div>